import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import { PublicStatus } from "@/pages/PublicStatus";
import { AuthCallback } from "@/components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Auth callback: session_id arrives in URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/status/:slug" element={<PublicStatus />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppProvider>
            <AppRouter />
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "rgba(12,16,23,0.95)",
                  color: "#f8fafc",
                  border: "1px solid rgba(204,255,0,0.35)",
                  fontFamily: "IBM Plex Sans, sans-serif",
                },
              }}
            />
          </AppProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
